import { Component, Vue } from 'vue-property-decorator';
import WithRender from './paymentdetails.html';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _axios from '@/services/axios';
import moment from 'moment';
import VuePhoneNumberInput from "vue-phone-number-input";
import { mapGetters } from 'vuex';
import { BookingType } from '@/types/Booking';
import { CartLine } from '@/types/CartTypes';

@WithRender
@Component({
  filters: {
    formateDate(value: string) {
      return moment(value).format('YYYY-MM-DD HH:mm A')
    }
  },
  components: {
    Loading,
    VuePhoneNumberInput
  },
  computed: {
    ...mapGetters("booking", { booking: "getBooking" }),
    ...mapGetters("originatorStore", { originator: "getOriginator", currency: "getWalletCurrency" }),
    ...mapGetters("shoppingCart", { cartLine: "getCartLine" }),
  }
})
export default class PaymentDetails extends Vue {
  cartLine!: CartLine;
  booking!: BookingType;
  senderNumber: string = "";
  receiverNumber="";
  senderNumberWithCountryCode = '';
  receiverNumberwithCountryCode = '';
  isSenderNumberValid: boolean = false;
  isReceiverNumberValid: boolean = false;
  valideSenderNumberMessage = '';
  valideReceiverNumberMessage = '';
  payerCountryCode='';
  payerNumber ='';

  ValidateReceiverNumber(payload: any) {
    this.receiverNumberwithCountryCode = payload.countryCallingCode + payload.nationalNumber;
    this.payerCountryCode = payload.countryCode;
    this.payerNumber = payload.nationalNumber;
    if (payload.isValid) {
      this.valideReceiverNumberMessage = '';
      this.isReceiverNumberValid = true;
    } else {
      this.isReceiverNumberValid =false;
      this.valideReceiverNumberMessage = "Please make sure mobile number is valid!";
    }
  }

  async proceed() {
    if (this.valideReceiverNumberMessage !== '')
    return;

    await this.$store.dispatch("shoppingCart/addReceiverNo", this.receiverNumberwithCountryCode);
    await this.$store.dispatch("shoppingCart/addPayerCountryCode", this.payerCountryCode);
    await this.$store.dispatch("shoppingCart/addPayerNumber", this.payerNumber);
    //await this.$store.dispatch("shoppingCart/addSenderNo", this.senderNumberWithCountryCode);
    this.$router.push("Checkout");
  }
}
